module.exports = __webpack_public_path__ + "static/img/honner4.983d6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honner/honner4.png
// module id = g/kC
// module chunks = 0